const SEO = [
	{
		page: "home",
		description:
			"I am a systems developer with expertise in multiple 3-D Frameworks, Game Engines, Rendering APIs, and Operating Systems. I have experience in building feature rich, performant, secure and reliable applications using a wide range of frameworks, technologies, and targeted platforms.",
		keywords: ["Nicholas", "Nicholas Barlow", "Nick Barlow", "Nick", "drigax", "whoisdrigax", "nicklowbar"],
	},

	{
		page: "about",
		description:
			"I am a systems developer with expertise in multiple 3-D Frameworks, Game Engines, Rendering APIs, and Operating Systems. I have experience in building feature rich, performant, secure and reliable applications using a wide range of frameworks, technologies, and targeted platforms.",
		keywords: ["Nicholas", "Nicholas Barlow", "Nick Barlow", "Nick", "drigax", "whoisdrigax", "nicklowbar"],
	},

	{
		page: "articles",
		description:
			"Here is a collection of writings where I share my thoughts on different aspects of programming, game design, leadership, art, and more.",
		keywords: ["Nicholas", "Nicholas Barlow", "Nick Barlow", "Nick", "drigax", "whoisdrigax", "nicklowbar"],
	},

	{
		page: "projects",
		description:
			"I've worked on a good number of projects over the years, and here are some of the ones I'm most proud of. I hope you enjoy them!",
		keywords: ["Nicholas", "Nicholas Barlow", "Nick Barlow", "Nick", "drigax", "whoisdrigax", "nicklowbar"],
	},

	{
		page: "contact",
		description:
			"I'd love to work with you on an interesting project! If you would like to collaborate, please feel free to reach out.",
		keywords: ["Nicholas", "Nicholas Barlow", "Nick Barlow", "Nick", "drigax", "whoisdrigax", "nicklowbar"],
	},
];

export default SEO;
